<template>
  <!-- eslint-disable -->
  <div class="quiz-item">
    <va-tinymce-input
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.data.content"
      :editor-height="120"
      title="Content"
      :forced-root-block-attrs="{ class: 'quiz-answer' }"
      auto-resize
      @update="content => updateAnswerContent(content)" />

    <v-btn v-if="displayAddDestinationItem" @click="addDestination">Add destination</v-btn>
    <v-btn class="mr-2" v-if="displayAddQuestionBtn" @click="addQuestion">Add question</v-btn>
  </div>
</template>

<script>
  import { QUESTION, DESTINATION } from "./constant";
  import cloneDeep from "lodash/cloneDeep";

  /* eslint-disable */
  export default {
    name: "QuizAnswer",
    props: {
      node: {
        type: Object,
        required: true,
      },
      tree: {
        type: Object,
        required: true,
      },
    },
    computed: {
      displayAddQuestionBtn() {
        if (this.node.data.type === "answer" && this.node.children.length === 0) return true;

        return false;
      },
      displayAddDestinationItem() {
        if (this.node.data.type === "answer" && this.node.children.length === 0) return true;

        return false;
      },
    },
    methods: {
      addQuestion() {
        this.tree.addNode(this.node, cloneDeep(QUESTION));
      },
      addDestination() {
        this.tree.addNode(this.node, cloneDeep(DESTINATION));
      },
      updateContent(content) {
        if (this.$refs.tinymce) {
          this.$refs.tinymce.updateContent(content);
        }
      },
      updateAnswerContent(content) {
        this.node.data.content = content;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
